import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-webapp-onboarding',
  templateUrl: './webapp-onboarding.component.html',
  styleUrls: ['./webapp-onboarding.component.css']
})
export class WebappOnboardingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
